// Normaliza a string`
// Remove caracteres especiais
export function sanitizeFileName(fileName: string) {
  return fileName
    .normalize('NFD')
    .replace(/[\u0300-\u036f]|[^a-zA-Z0-9._-]/g, '');
}

/**
 * Sanitizes a string by keeping only characters that match the allowed regex pattern
 * @param input - The string to sanitize
 * @returns String containing only the allowed characters
 */
export function adobeCommerceSanitize(input: string): string {
  return input.replace(/[^A-Za-zÀ-ÖØ-öø-ÿ0-9,\-_.'’`&\s]{1,255}/g, '');
}
